/* The masterminds' staff side: the member view's wins (Panel.jsx), the groups and the registers on Recordings
   and dates, in the master brand (white, the ink, greys as tints of it, gold only for small accents that carry no
   text: the ticked action's dot and the gold bar on a month's line). Every colour is a token
   (styles/tokens.css). The panel is 2 columns at laptop width, 1 under 1100px, and every row stacks
   under 760px, as the person page's other cards do. */

.amm-panel .ad-card-head { align-items: center; }
.amm-evidence-link { margin-left: auto; }
.amm-pad { padding: 20px 22px; }
.amm-body { display: flex; flex-direction: column; }
.amm-strip {
  padding: 14px 22px; border-bottom: 1px solid var(--shell-ink-08); background: var(--shell-ink-02);
  display: flex; flex-direction: column; gap: 4px;
}
.amm-strip-line { font-size: 14px; font-weight: 700; line-height: 1.5; }
.amm-billed { font-weight: 600; }
.amm-billed a { font-weight: 700; }
.amm-cols { display: grid; grid-template-columns: minmax(0, 1.35fr) minmax(0, 1fr); }
.amm-col { display: flex; flex-direction: column; min-width: 0; }
.amm-col + .amm-col { border-left: 1px solid var(--shell-ink-08); }
.amm-sec { padding: 18px 22px 20px; display: flex; flex-direction: column; gap: 10px; border-bottom: 1px solid var(--shell-ink-08); min-width: 0; }
.amm-col .amm-sec:last-child { border-bottom: none; }
.amm-sec-head { display: flex; align-items: baseline; justify-content: space-between; gap: 6px 12px; flex-wrap: wrap; }
.amm-h3 { margin: 0; font-size: 16px; font-weight: 800; }
.amm-h4 { margin: 6px 0 0; font-size: 13px; font-weight: 800; letter-spacing: 0.06em; text-transform: uppercase; color: var(--shell-ink-60); }
.amm-count { font-size: 13px; font-weight: 700; color: var(--shell-ink-60); }
.amm-meta { margin: 0; font-size: 13px; line-height: 1.5; color: var(--shell-ink-72); }
.amm-muted { margin: 0; font-size: 13px; line-height: 1.5; color: var(--shell-ink-60); }
.amm-foot { padding: 12px 22px 16px; border-top: 1px solid var(--shell-ink-08); }
.amm-said { margin: 0; font-size: 13px; font-weight: 700; line-height: 1.5; }
.amm-goal {
  margin: 0; padding: 12px 14px; border-radius: 10px; background: var(--shell-ink-03); font-size: 15px; font-weight: 700;
  line-height: 1.5; white-space: pre-line; overflow-wrap: anywhere;
}
.amm-form { display: flex; flex-direction: column; gap: 10px; }
.amm-form-pair { display: grid; grid-template-columns: minmax(0, 1fr) minmax(0, 1fr); gap: 12px; }
.amm-row-actions { display: inline-flex; align-items: center; gap: 8px 10px; flex-wrap: wrap; }
.amm-add { padding-top: 6px; border-top: 1px dashed var(--shell-ink-14); }

/* ---- Actions ------------------------------------------------------------------------------------- */
.amm-actions { list-style: none; margin: 0; padding: 0; border: 1px solid var(--shell-ink-10); border-radius: 10px; overflow: hidden; }
.amm-action {
  display: grid; grid-template-columns: 16px minmax(0, 1fr) auto; gap: 10px 12px; align-items: start; padding: 12px 14px;
  border-bottom: 1px solid var(--shell-ink-06);
}
.amm-action:last-child { border-bottom: none; }
.amm-action--archived { background: var(--shell-ink-02); }
.amm-action--archived .amm-action-body { color: var(--shell-ink-60); }
.amm-tick { width: 14px; height: 14px; margin-top: 3px; border-radius: 7px; border: 1.5px solid var(--shell-ink-30); }
.amm-tick--on { border-color: var(--shell-gold); background: var(--shell-gold); }
.amm-action-main { display: flex; flex-direction: column; gap: 4px; min-width: 0; }
.amm-action-body { font-size: 14px; font-weight: 700; line-height: 1.45; overflow-wrap: anywhere; }
.amm-action-lines { display: flex; align-items: center; gap: 4px 12px; flex-wrap: wrap; font-size: 12px; color: var(--shell-ink-60); }
.amm-note { font-size: 13px; line-height: 1.5; color: var(--shell-ink-72); padding: 6px 10px; border-radius: 8px; background: var(--shell-ink-03); overflow-wrap: anywhere; }
.amm-note-who { font-weight: 700; color: var(--shell-ink); }
.amm-action-side { display: flex; flex-direction: column; align-items: flex-end; gap: 6px; min-width: 0; }
.amm-verdict-label { font-size: 11px; font-weight: 800; letter-spacing: 0.08em; text-transform: uppercase; color: var(--shell-ink-60); }
.amm-verdict { display: inline-flex; align-items: center; gap: 6px; flex-wrap: wrap; justify-content: flex-end; }
.amm-verdict .ad-options--row { flex-wrap: nowrap; gap: 4px; }
.amm-verdict .ad-options--row .ad-option { flex: 0 0 auto; height: 28px; padding: 0 9px; border-radius: 7px; font-size: 12px; border-width: 1px; }
.amm-verdict-read { font-size: 13px; font-weight: 700; }

.amm-next {
  padding: 14px 16px; border-radius: 10px; background: var(--shell-ink-04); box-shadow: inset 4px 0 0 var(--shell-gold);
  display: flex; flex-direction: column; gap: 10px;
}
.amm-next-title { font-size: 15px; font-weight: 800; }
.amm-next .ad-field { max-width: 420px; }

.amm-earlier { display: flex; flex-direction: column; gap: 8px; }
.amm-month { border: 1px solid var(--shell-ink-10); border-radius: 10px; overflow: hidden; }
.amm-month .amm-actions { border: none; border-top: 1px solid var(--shell-ink-08); border-radius: 0; }
.amm-month-head {
  width: 100%; min-height: 44px; padding: 10px 14px; border: none; background: var(--shell-bg); color: var(--shell-ink);
  display: flex; align-items: center; justify-content: space-between; gap: 6px 12px; text-align: left;
  font-size: 13px; font-weight: 700; line-height: 1.45; font-family: inherit; flex-wrap: wrap;
}
.amm-month-head:hover { background: var(--shell-ink-02); }
.amm-month-head[aria-expanded="true"] { background: var(--shell-ink-03); }

/* ---- Attendance and the guarantee -------------------------------------------------------------------- */
.amm-pill {
  align-self: flex-start; min-height: 26px; padding: 3px 10px; border-radius: 13px; font-size: 12px; font-weight: 700; line-height: 1.5;
  background: var(--shell-ink-06); border: 1px solid var(--shell-ink-06); display: inline-flex; align-items: center;
}
.amm-pill--at_limit { background: var(--shell-bg); border-color: var(--shell-ink); }
.amm-pill--void { background: var(--shell-ink); border-color: var(--shell-ink); color: var(--shell-on-ink); }
.amm-sessions { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; border-top: 1px solid var(--shell-ink-06); }
.amm-session {
  display: grid; grid-template-columns: 96px minmax(0, 1fr) auto auto; gap: 4px 12px; align-items: center; padding: 9px 0;
  border-bottom: 1px solid var(--shell-ink-06); font-size: 13px;
}
.amm-session-when { font-weight: 700; font-variant-numeric: tabular-nums; }
.amm-session-group { color: var(--shell-ink-72); min-width: 0; }
.amm-mark { font-weight: 700; }
.amm-mark--none, .amm-mark--excused { color: var(--shell-ink-60); }
.amm-session-link { display: inline-flex; align-items: center; min-height: 24px; font-size: 12px; font-weight: 700; color: var(--shell-ink); }
.amm-session-note { grid-column: 2 / -1; font-size: 12px; color: var(--shell-ink-60); }

/* ---- Wins -------------------------------------------------------------------------------------------- */
.amm-wins { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 8px; }
.amm-win { padding: 12px 14px; border-radius: 10px; border: 1px solid var(--shell-ink-10); display: flex; flex-direction: column; gap: 6px; }
.amm-win-title { font-size: 14px; font-weight: 700; line-height: 1.45; overflow-wrap: anywhere; }
.amm-win-line { display: flex; align-items: center; gap: 6px 10px; flex-wrap: wrap; font-size: 13px; color: var(--shell-ink-66); }
.amm-win-detail { font-size: 13px; line-height: 1.5; color: var(--shell-ink-72); white-space: pre-line; overflow-wrap: anywhere; }
.amm-winform { padding: 12px 14px; border-radius: 10px; background: var(--shell-ink-03); }

/* ---- The evidence report ------------------------------------------------------------------------------- */
.amm-report { display: flex; flex-direction: column; gap: 22px; max-width: 1040px; }
.amm-report-tools { display: flex; flex-direction: column; gap: 10px; }
.amm-report-head { display: flex; flex-direction: column; gap: 6px; padding-bottom: 16px; border-bottom: 2px solid var(--shell-ink); }
.amm-report-sec { display: flex; flex-direction: column; gap: 10px; }
.amm-report-h2 { margin: 0; font-size: 19px; font-weight: 800; }
.amm-report-month { display: flex; flex-direction: column; gap: 8px; padding: 12px 0 4px; box-shadow: inset 0 1px 0 var(--shell-ink-08); }
.amm-table { width: 100%; border-collapse: collapse; font-size: 13px; line-height: 1.5; }
.amm-table th {
  text-align: left; padding: 8px 10px; font-size: 11px; font-weight: 800; letter-spacing: 0.08em; text-transform: uppercase;
  color: var(--shell-ink-60); background: var(--shell-ink-03); border-bottom: 1px solid var(--shell-ink-10);
}
.amm-table td { padding: 8px 10px; vertical-align: top; border-bottom: 1px solid var(--shell-ink-06); overflow-wrap: anywhere; }
.amm-cell-sub { display: block; color: var(--shell-ink-60); }
.amm-table td.amm-nowrap { white-space: nowrap; }

/* ---- Recordings and dates: the groups' own controls ---------------------------------------------------- */
.amm-group-tools { display: flex; align-items: center; gap: 8px 10px; flex-wrap: wrap; }
.amm-rename { display: flex; align-items: flex-end; gap: 8px; flex-wrap: wrap; padding: 12px 20px; border-bottom: 1px solid var(--shell-ink-06); }
.amm-rename .ad-field { flex: 1 1 220px; }
.amm-groups-foot {
  grid-column: 1 / -1; padding: 14px 20px; border-radius: 14px; border: 1px dashed var(--shell-ink-20);
  display: flex; align-items: center; gap: 8px 12px; flex-wrap: wrap;
}
.amm-groups-name { display: flex; align-items: center; gap: 8px; font-size: 12px; font-weight: 800; letter-spacing: 0.06em; text-transform: uppercase; color: var(--shell-ink-60); margin-right: 4px; }
.amm-reg-tools { display: flex; align-items: center; gap: 8px 12px; flex-wrap: wrap; }

/* ---- Between laptop and phone, and on a phone ---------------------------------------------------------- */
@media (max-width: 1100px) {
  .amm-cols { grid-template-columns: minmax(0, 1fr); }
  .amm-col + .amm-col { border-left: none; border-top: 1px solid var(--shell-ink-08); }
}
@media (max-width: 760px) {
  .amm-strip, .amm-sec, .amm-pad, .amm-foot { padding-left: 16px; padding-right: 16px; }
  .amm-action { grid-template-columns: 16px minmax(0, 1fr); }
  .amm-action-side { grid-column: 2; align-items: flex-start; }
  .amm-verdict { justify-content: flex-start; }
  .amm-verdict .ad-options--row { flex-wrap: wrap; }
  .amm-form-pair { grid-template-columns: minmax(0, 1fr); }
  .amm-session { grid-template-columns: minmax(0, 1fr) auto; }
  .amm-session-group { grid-column: 1; }
  .amm-session-note { grid-column: 1 / -1; }
  .amm-table thead { display: none; }
  .amm-table, .amm-table tbody, .amm-table tr, .amm-table td { display: block; width: 100%; }
  .amm-table tr { padding: 8px 0; border-bottom: 1px solid var(--shell-ink-08); }
  .amm-table td { padding: 2px 0; border-bottom: none; }
  .amm-rename { padding-left: 16px; padding-right: 16px; }
}
